import React from 'react';
var ArrowDropDown = function () {
    return (React.createElement("svg", { width: "24", height: "24", viewBox: "0 0 24 24", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M7 9.5L12 14.5L17 9.5H7Z", fill: "white" })));
};
export default ArrowDropDown;
